import {IconButton} from '@wandb/components';
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import classNames from 'classnames';
import React, {useMemo, useState} from 'react';

import {Analytics} from '../../../../services/analytics';
import {ColorPalettePreview} from '../colorPalette/ColorPalettePreview';
import {useMaybeWorkspaceSettingsContext} from '../WorkspaceSettingsContextProvider';
import {useSemanticLegendSettingsContext} from './SemanticLegendSettingsContextProvider';
import {getAllPalettesForNumberOfBuckets} from './utils/colorPalettes';
import {useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig} from './utils/useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig';

export const SemanticLegendsPaletteWithCategoricalConfig = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {semanticLegendSettings} = useSemanticLegendSettingsContext();
  const workspaceSettings = useMaybeWorkspaceSettingsContext();
  const palettes = useMemo(
    () =>
      getAllPalettesForNumberOfBuckets(
        semanticLegendSettings?.numberOfBuckets ?? 0
      ),
    [semanticLegendSettings?.numberOfBuckets]
  );

  const getSelectedPalette =
    useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig();

  return (
    <DropdownMenu.Root open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.Trigger>
        <IconButton
          isActive={isOpen}
          icon="color-palette"
          variant="ghost"
          aria-label="Color presets"
          size="sm"
          onPress={() => {
            setIsOpen(true);
          }}
        />
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content align="center">
          <div className="px-12">
            <div className="py-6 text-[15px] font-semibold text-moon-800 dark:text-moon-200">
              Color presets
            </div>
            <div className="flex flex-col py-4">
              {palettes.map(({colors, palette}, i) => (
                <div
                  className="w-[210px] py-6"
                  key={i}
                  onClick={() => {
                    setIsOpen(false);
                    Analytics.track('Semantic legend palette changed', {
                      newValue: palette,
                    });
                    workspaceSettings?.updateSemanticLegendPalette(palette);
                  }}>
                  <ColorPalettePreview
                    data-test={`palette-${palette}`}
                    colors={colors}
                    // custom border effect for hover and selecting
                    borderClassName={classNames(
                      'hover:outline-1 p-4',
                      palette ===
                        getSelectedPalette(semanticLegendSettings?.yAxisValue)
                        ? 'outline-teal-450 dark:outline-teal-550'
                        : 'outline-0'
                    )}
                    // thinner because it's within the dropdown menu
                    className="h-10"
                  />
                </div>
              ))}
            </div>
          </div>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};
